import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Searchbar, Button, EventCard, CardLoader } from "app/components";
import mixpanel from "mixpanel-browser";

import { getAllEvents } from '../landing-page/api';

import './style';

const AllEvents = () => {
  const location = useLocation();

  const [activeTab, setActiveTab] = useState(location.state || 'all');
  const [loading, setLoading] = useState(true);

  const { userData } = useSelector((state) => state.app);
  const { selectedCity } = useSelector((state) => state.landingPage);
  const { allEvents } = useSelector((state) => state.allEvents);
  const navigate = useNavigate();

  const handleEventSelect = (_id, isResale) => {
    if (isResale) navigate(`/${_id}`);
    else navigate(`/event/${_id}`);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setLoading(true);
    // Simulate loading for tab change
    setTimeout(() => setLoading(false), 300);
  };

  const handleBack = () => {
    
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);

    getAllEvents(selectedCity.label, () => {
      setLoading(false);
    });
  }, [selectedCity]);

  const getActiveTabEvents = () => {
    if (activeTab === 'all') return allEvents?.allEvents || [];
    else if (activeTab === 'primary') return allEvents?.primaryEvents || [];
    else return allEvents?.secondaryEvents || [];
  };

  return (
    <div className="relative mt-[100px]">
      <Helmet>
        <title>Events Around You</title>
        <meta
          name="title"
          content="Explore a Variety of Events in India | Buy Tickets on Take My Tickets| Take My Tickets"
        />
        <meta
          name="description"
          content="Find and buy tickets for concerts, sports events, music festivals, and more on India's top online ticket marketplace."
        />
      </Helmet>
      <div className="w-full h-auto px-[80px] pt-[42px] flex flex-col gap-[40px] all-events-container">
        <div className="w-[512px] flex flex-col gap-[36px] items-center mx-auto search-bar-container">
          <div className="flex gap-[20px] header">
            <h1 className="heading-48 heading">Browse events</h1>
            <span className="heading-48 heading">👀</span>
          </div>

          {window.innerWidth < 650 ? (
            <Searchbar
              type="mobile"
              top="0px"
              width="100%"
              height="80vh"
              onSelect={handleEventSelect}
              onClickBack={handleBack}
            />
          ) : (
            <Searchbar
              type="global"
              width="800px"
              height="55vh"
              onSelect={handleEventSelect}
            />
          )}
        </div>
        <div className="flex flex-col gap-[36px] items-center eventList">
          <div className="flex gap-3 button-group">
            <Button
              onClick={() => handleTabChange('all')}
              rounded={true}
              type="tertiary"
              className={`bt ${activeTab === 'all' ? "btn" : ''}`}
            >
              All Events ({loading ? '...' : allEvents?.allEvents?.length || 0})
            </Button>
            <Button
              onClick={() => handleTabChange('primary')}
              rounded={true}
              type="tertiary"
              className={`bt ${activeTab === 'primary' ? "btn" : ''}`}
            >
              Primary ({loading ? '...' : allEvents?.primaryEvents?.length || 0})
            </Button>
            <Button
              onClick={() => handleTabChange('secondary')}
              rounded={true}
              type="tertiary"
              className={`bt ${activeTab === 'secondary' ? "btn" : ''}`}
            >
              Only Resale ({loading ? '...' : allEvents?.secondaryEvents?.length || 0})
            </Button>
          </div>

          <div className="flex gap-[24px] flex-wrap items-center event-card-container justify-center">
            {loading ? (
              <div className="mb-[24px] flex gap-12">
                <CardLoader 
                  count={3} 
                    type="event" 
                    cardStyle={`${window.innerWidth > 650 ? 'w-[355px]' : 'w-[327px]'} `}
                    className='relative rounded-xl mb-5 w-auto overflow-hidden shrink-0 text-left text-sm text-black font-general-sans'
                  />
              </div>
            ) : getActiveTabEvents()?.length ? (
              getActiveTabEvents()?.map((event) => (
                <div className="event-card">
                  <EventCard
                    width={window.innerWidth > 650 ? '355px' : '327px'}
                    height="358px"
                    url={
                      event.image !== 'string'
                        ? event.image
                        : '/assets/images/Image-upload.svg'
                    }
                    id={event.id}
                    eventName={event.name}
                    eventDate={event.start_date}
                    eventType={event.type}
                    startPrice={event.isPrimary ? (Math.min(...(event?.smp_detail_entity_set || []).map(p => p.price)) || 0) : event.start_price}
                    eventSlug={event.id}
                    eventCity={event.isPrimary ? event.event_address?.name : event.venue}
                    resale={!event.isPrimary}
                    isTrending={event.is_trending}
                    onClick={() => {
                        mixpanel.track("Event_Clicked_From_Browse", {
                          "event_id": event?.id,                  
                          "event_name": event?.name,             
                          "user_id": userData?._id || "Anonymous",    
                          "page_url": window.location.href,  
                        });
                        if (event.isPrimary) navigate(`/event/${event.id}`);
                        else navigate(`/${event.id}`);
                    }}
                  />
                </div>
              ))
            ) : (
              <div className="noeventscontainer pb-[64px]">
                <img
                  src="assets/images/notrendingevents.svg"
                  alt="Oops, no events found!"
                  className="noeventsimage"
                />
                <div className="text-16 text-center">Oops, no events found!</div>
                {activeTab === 'secondary' && (<Button
                  className="cursor-pointer mt-6"
                  onClick={() => navigate('/request')}
                >
                  Request an event for resale
                </Button>)}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllEvents;
